import { render, staticRenderFns } from "./ViewOrganizationUserRiders.vue?vue&type=template&id=1152fe6a&lang=true"
import script from "./ViewOrganizationUserRiders.vue?vue&type=script&lang=js"
export * from "./ViewOrganizationUserRiders.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports